module.exports = [
  {
    "id": 1,
    "text": "Jukolan talo, eteläisessä Hämeessä, seisoo erään mäen pohjaisella rinteellä, liki Toukolan kylää. Sen läheisin ympäristö on kivinen tanner, mutta alempana alkaa pellot, joissa, ennenkuin talo oli häviöön mennyt, aaltoili teräinen vilja.",
    "source": "Seitsemän veljestä, Aleksis Kivi, 1891"
  },
  {
    "id": 2,
    "text": "Mieleni minun tekevi, aivoni ajattelevi lähteäni laulamahan, saa'ani sanelemahan, sukuvirttä suoltamahan, lajivirttä laulamahan. Sanat suussani sulavat, puhe'et putoelevat, kielelleni kerkiävät, hampahilleni hajoovat.",
    "source": "Kalevala, Elias Lönnrot, 1849"
  },
  {
    "id": 3,
    "text": "Mennyttä aikaa muistelen niin mielelläni vielä; niin moni armas tähtönen minulle viittaa siellä. Ken mua seuraa retkelle nyt Näsijärven rannalle?  Siell' opin miehen tuntemaan, hän sotamies ol' ennen, nyt vänrikki ol' arvoltaan, vaikk' onni näytti menneen. Ties kuinka samaan talohon satuimme saamaan asunnon.  Mies olin silloin kelvokas, niin luulin, vaikka miksi, Min' olin ylioppilas, mainittiin maisteriksi; hupaasti elin \"mensallain\", Stool, hän söi armoleipää vain.",
    "source": "Vänrikki Stoolin tarinat, J. L. Runeberg, 1870"
  },
  {
    "id": 4,
    "text": "Se varsin varmaa on, en sitä kieltää saata, jo tänne Ruotsin tie käy kohti Frankinmaata, on heidän Breitenfeld, on lyöty joukkomme. Harz turhaan harjojansa nostaa myrskylle: Tulen Ilmenausta, -- siellä välkkyi Ruotsin rauta; Schleusingenissa mua uhkas kahleet, hauta, ja Arnstadtissa samoin, Schweinfurthissa myös. Koko Königshofen taasen valvoi vallityöss'; sen portit aukesi, kun näkyi Ruotsin hampaat, ma kansan asestin, -- ne pakeni kuin lampaat.",
    "source": "Suomen herttuatar, Z. Topelius, 1874"
  }
];

